import axios from 'axios'

export const getDashboardData = ({ commit }, { filter, branchoffice } = {}) => {
  commit('setLoading', true)
  return axios.get('/api/dashboard/getData', { params: { filter, branchoffice } })
    .then((response) => {
      commit('setData', response.data.data)
    })
    .finally(() => {
      commit('setLoading', false)
    })
}
